<template>
  <div class="row">
    <div class="col-md-12">
      <div class="x_panel">
        <div class="x_title">
          <h4>派車資料</h4>
        </div>
        <div class="row">
          <div class="col-md-6">
            <h5 class="col-md-4">單號:</h5>
            <h5 class="col-md-8">{{ transaction.id }}</h5>
          </div>
          <div class="col-md-6">
            <h5 class="col-md-4">派車員:</h5>
            <h5 class="col-md-8">
              {{ transaction.call_method }}
            </h5>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <h5 class="col-md-4">叫車種類:</h5>
            <h5 class="col-md-8">立即叫車</h5>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <h5 class="col-md-4">叫車時間:</h5>
            <h5 class="col-md-8">{{ transaction.createdAt }}</h5>
          </div>
          <div class="col-md-6">
            <h5 class="col-md-4">預計抵達時間</h5>
            <h5 class="col-md-8">{{ estimatedTime }} 分</h5>
          </div>
          <div class="col-md-6">
            <h5 class="col-md-4">預約時間:</h5>
            <h5 class="col-md-8">{{ getBookingTime() }}</h5>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { reqOrderDetail } from '@/api/hailState-v2'

export default {
  props: {
    transaction: Object,
  },
  computed: {
    ...mapState('hailStateV2', {
      vx_billModal: (state) => state.billModal,
    }),
    estimatedTime() {
      // 先確保 transaction 存在且有 id
      if (!this.transaction || !this.transaction.id) {
        return '載入中...'
      }

      // 後派單檢查
      if (
        this.transaction.passenger_note &&
        this.transaction.passenger_note.includes('後派單')
      ) {
        return '---'
      }
      this.fetchEstimatedTime(this.transaction.id)
      return this.currentEstimatedTime || '---'
    },
  },
  data() {
    return {
      currentEstimatedTime: null,
    }
  },
  methods: {
    ...mapActions('hailStateV2', {
      vx_fetchBillList: 'fetchBillList',
    }),
    async fetchEstimatedTime(id) {
      try {
        if (!id) {
          console.log('訂單ID不存在:', id)
          return
        }

        console.log('正在查詢訂單ID:', id)
        const { result } = await reqOrderDetail(id)
        // 直接設定 API 回傳的 estimatedTime，可能是 null
        this.currentEstimatedTime = result ? result.estimatedTime : null
      } catch (error) {
        console.error('獲取訂單資料失敗:', error)
        this.currentEstimatedTime = null
      }
    },
    getBookingTime() {
      const msg = this.transaction.passenger_note
      //如果是後派單才會有預約時間
      if (msg && msg.includes('後派單')) {
        const dayMatch = msg.match(/預約時間:.*?(\d{4}-\d{2}-\d{2})/)
        const timeMatch = msg.match(/預約時間:.*?(\d{2}:\d{2}:\d{2})/)

        if (dayMatch && dayMatch[1] && timeMatch && timeMatch[1]) {
          return `${dayMatch[1]} ${timeMatch[1]}` // 組合日期和時間
        }
      }
      return '無' // 如果沒有匹配到時間，返回 '無'
    },
  },
  created() {
    this.vx_fetchBillList()
  },
}
</script>



// WEBPACK FOOTER //
// src/pages/transaction/components/Dispatch.vue